import { ArrowLeft, MoreHorizontal } from 'lucide-react'
import type { ComponentProps } from 'react'
import { Button } from 'shared/components/ui/button'
import { useTranslate } from 'shared/lib/i18n'

/**
 * The parcel cards' small parts, in the hub's look (the redesign's reference; a
 * section's title and the «i» are the shared `section.tsx`, the facts `facts.tsx`):
 * the back arrow before a card's heading; the «⋯» trigger of a card's rare acts.
 */

/** The arrow before a card's heading, back to the search. */
export function BackButton({ onBack }: { onBack: () => void }) {
	const { t } = useTranslate()
	return (
		<Button
			variant='ghost'
			size='icon'
			onClick={onBack}
			aria-label={t('parcels.detailBack')}
			title={t('parcels.detailBack')}
			data-testid='parcel-back'
		>
			<ArrowLeft />
		</Button>
	)
}

/** The «⋯» button that opens a card's menu of rare acts. */
export function MoreButton({ testId, ...props }: { testId: string } & ComponentProps<typeof Button>) {
	const { t } = useTranslate()
	return (
		<Button variant='outline' size='icon' aria-label={t('parcels.moreActions')} data-testid={testId} {...props}>
			<MoreHorizontal />
		</Button>
	)
}
